import script from "./InputDate.vue?vue&type=script&setup=true&lang=js"
export * from "./InputDate.vue?vue&type=script&setup=true&lang=js"

import "./InputDate.vue?vue&type=style&index=0&id=4b9e439f&lang=scss"

const __exports__ = script;

export default __exports__